import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import {injectIntl, intlShape} from 'react-intl';
import * as FormatUtils from '../utils/formatUtils';
import styles from './purchaseInfo.scss';

@injectIntl
@CSSModules(styles, {allowMultiple: true})
class PurchaseInfo extends React.Component {

  static propTypes = {
    intl: intlShape,
    purchase: PropTypes.shape({
      externalId: PropTypes.string.isRequired,
      dateTime: PropTypes.string.isRequired,
      retailerName: PropTypes.string.isRequired
    }),
    className: PropTypes.string,
  };

  render() {
    const {purchase, intl:{formatMessage}} = this.props;
    const className = classNames('purchaseInfo', this.props.className);
    return (
      <div styleName={className}>
        <div styleName="retailer" data-at="retailerName">{formatMessage({id:'purchase.info.label.retailerName'})} {purchase.retailerName}</div>
        <div data-at="purchaseDate">{formatMessage({id:'purchase.info.label.purchaseDate'})} {FormatUtils.transformDate(purchase.dateTime)}</div>
        <div data-at="purchaseExternalId">{formatMessage({id:'purchase.info.label.purchaseExternalId'})} {purchase.externalId}</div>
      </div>
    );

  }
}

export default PurchaseInfo;



// WEBPACK FOOTER //
// ./src/purchases/PurchaseInfo.js